import cooperplaceApi from 'services/apis/cooperplace';

export function getReasons(fromGroupSlug, groupSlug) {
  return cooperplaceApi.get(`/adjustments/reasons`, { params: { fromGroupSlug, groupSlug } });
}

export function getGroups() {
  return cooperplaceApi.get('/adjustments/groups');
}

export function createAdjustment(travelId, payload) {
  return cooperplaceApi.post(`/travels/${travelId}/adjustments`, payload);
}

export function getTravelAdjustments(travelId) {
  return cooperplaceApi.get(`/travels/${travelId}/adjustments`);
}

export function finishAdjustment(travelId, id, payload) {
  return cooperplaceApi.put(`/travels/${travelId}/adjustments/${id}/finish`, payload);
}

export function cancelAdjustment(travelId, id, payload) {
  return cooperplaceApi.put(`/travels/${travelId}/adjustments/${id}/cancel`, payload);
}

export function getTotals(travelId) {
  return cooperplaceApi.get(`/travels/${travelId}/adjustments/totals`);
}

export function getUserGroups() {
  return cooperplaceApi.get('/adjustments/user-groups');
}